import { render, staticRenderFns } from "./CoinsByVariation.vue?vue&type=template&id=1aa9f029&"
import script from "./CoinsByVariation.vue?vue&type=script&lang=js&"
export * from "./CoinsByVariation.vue?vue&type=script&lang=js&"
import style0 from "./CoinsByVariation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports